import { render, staticRenderFns } from "./DetailsPaymentsItem.vue?vue&type=template&id=2138daf7&scoped=true&"
import script from "./DetailsPaymentsItem.vue?vue&type=script&lang=js&"
export * from "./DetailsPaymentsItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPaymentsItem.vue?vue&type=style&index=0&id=2138daf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2138daf7",
  null
  
)

export default component.exports